// extracted by mini-css-extract-plugin
export default {"tableOverflow":"Table_tableOverflow__3eaXA","centered":"Table_centered__fMtJA","tablePaginator":"Table_tablePaginator__67Vk9"};